/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent } from "@material-ui/core";
import AssessmentStatusLabel from "src/components/AssessmentStatusLabel/AssessmentStatusLabel";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    textAlign: "center",
    fontWeight: "bold",
  },
}));

function AssessmentResultCard({ data, className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        {t("VendorSelf.status")}
        <br />
        <AssessmentStatusLabel statusCode={data.statusCode || ""} />
        <br />
        {t("VendorSelf.result")}
        <br />
        <AssessmentStatusLabel statusCode={data.resultCode || ""} />
        <br />
        {t("VendorSelf.fullScore")}
        <br />
        {parseFloat(data.fullScore || 0).toFixed(2)}
        <br />
        {t("VendorSelf.score")}
        <br />
        {data.weight && data.weight > 0
          ? parseFloat(data.scoreWeight || 0).toFixed(2)
          : parseFloat(data.averageScore || 0).toFixed(2)}
      </CardContent>
    </Card>
  );
}

AssessmentResultCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
};

export default AssessmentResultCard;
